<template>
    <div class="page">
        <step-section></step-section>
        <div class="checkout-page border-bottom">
                <div class="main-checkout-row grey-bg">
                    <div class="checkout_info ">
                        <div class="back">
                            <a href="#"><img src="../../../img/icon/arrow-down-black.svg" alt="Back to">Back to</a>
                            <img src="../../../img/header/logo.svg" alt="" class="logo">
                        </div>
                        <div class="one__blck">
                                <div class="garant">
                                <div class="title">
                                    <p class="med p-black p-bold">Tecknael garanterar:</p>
                                </div>
                                <div class="garant__items">

                                    <div class="garant-item">
                                        <div class="img">
                                            <img src="/img/header/shield.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <p class="min p-dgrey">Elbyte med prisgaranti</p>
                                        </div>
                                    </div>
                                    <div class="garant-item">
                                        <div class="img">
                                            <img src="/img/header/scales.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <p class="min p-dgrey">Jämför och byt gratis </p>
                                        </div>
                                    </div>
                                    <div class="garant-item">
                                        <div class="img">
                                            <img src="/img/header/calendar.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <p class="min p-dgrey">14 dagars ångerrätt</p>
                                        </div>
                                    </div>
                                    <div class="garant-item mobile-none">
                                        <div class="img">
                                            <img src="/img/candel.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <p class="min p-dgrey">A switch never causes any power failure</p>
                                        </div>
                                    </div>
                                    <div class="garant-item mobile-none">
                                        <div class="img">
                                            <img src="/img/cash2.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <p class="min p-dgrey">In average our customers save 2000 Kr/year</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        <div class="second__blck   d-none d-md-block ">

                                <div class="price__info">
                                    <div class="collapsible__el" :class="{'active': collapses2}">
                                        <div class="title_el" @click="collapses2 = !collapses2">
                                            <p class="p-white  p-bold">Fixed Price</p>
                                            <p class="min-min p-white">Show details <img
                                                    src="/img/icon/arrow-down-white.svg" alt=""></p>
                                        </div>
                                        <transition name="fade">
                                            <div class="content" v-if="collapses2">
                                                <div class="row">
                                                    <div class="col-8">
                                                        <div class="title">
                                                            <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                            <p class="p-gray2 minimum">(incl. electricity certificate, excl.
                                                                VAT)</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="cost">
                                                            <p class="p-dgrey med-max">45.90</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-8">
                                                        <div class="title">
                                                            <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                            <p class="p-gray2 minimum">(incl. electricity certificate, excl.
                                                                VAT)</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="cost">
                                                            <p class="p-dgrey med-max">45.90</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-8">
                                                        <div class="title">
                                                            <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                            <p class="p-gray2 minimum">(incl. electricity certificate, excl.
                                                                VAT)</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="cost">
                                                            <p class="p-dgrey med-max">45.90</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-8">
                                                        <div class="title">
                                                            <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                            <p class="p-gray2 minimum">(incl. electricity certificate, excl.
                                                                VAT)</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="cost">
                                                            <p class="p-dgrey med-max">45.90</p>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </transition>
                                        <div class="less_price">
                                            <div class="row align-items-center">
                                                <div class="col-6 col-md-6 col-lg-7">
                                                    <div class="total">
                                                        <p class="p-blue">Total:</p>
                                                    </div>
                                                </div>
                                                <div class="col-6 col-md-6 col-lg-5">
                                                    <div class="total-cost">
                                                        <p class="p-black">
                                                            <span class="number">1250</span>
                                                            <span>kr</span>
                                                            <span>month SEK</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="bindings">
                                    <div class="collapsible__el " :class="{'active': collapses1}">
                                        <div class="title_el" @click="collapses1 = !collapses1">
                                            <p class="min"><b>Binding time</b>
                                                <span class="quest__in_icon">
                                                    </span>
                                            </p>
                                            <p class="min p-blue">9 months</p>
                                        </div>
                                        <transition name="fade">
                                            <div class="content" v-if="collapses1">
                                                <p class="min-min">If the consumer chooses to break the contract entered in
                                                    early, the Lighthouse has the right to charge a ransom fee. This
                                                    exercise fee is calculated at 20% of the agreed energy price for
                                                    estimated consumption during the remaining part of the contract period
                                                    plus an administrative fee of SEK 450 incl. VAT. The remaining contract
                                                    period is counted in whole months. The monthly consumption is calculated
                                                    as one twelfth of the annual consumption stated by the electricity grid
                                                    owner last. At the customer's definitive relocation, where no new plant
                                                    is put into use, the agreement can be terminated prematurely without a
                                                    ransom charge being charged.</p>
                                            </div>
                                        </transition>

                                    </div>

                                </div>

                                <div class="garant desktop__none">
                                    <div class="garant__items">
                                        <div class="garant-item">
                                            <div class="img">
                                                <img src="/img/candel.svg" alt="">
                                            </div>
                                            <div class="info">
                                                <p class="min-min p-dgrey">A switch never causes any power failure</p>
                                            </div>
                                        </div>
                                        <div class="garant-item">
                                            <div class="img">
                                                <img src="/img/cash2.svg" alt="">
                                            </div>
                                            <div class="info">
                                                <p class="min-min p-dgrey">In average our customers save 2000 Kr/year</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="checkout-form">
                            <div class="logo">
                                <img src="../../../img/telinet.svg" alt="">
                            </div>
                            <div class="main-form">
                                <div class="radio-group">
                                    <p class="label">Leverans</p>
                                    <div class="start-radio error">
                                        <div class="radio-item brdr-bottom help-radio">
                                            <label>
                                                <input type="radio" class="main-radio" name="radio1" value="j1" v-model="jag1">
                                                <span class="radio"></span>
                                                <span class="p-black min p-bold p-black">Jag vill byta elabolag</span>
                                            </label>
                                            <transition name="fade">
                                                <div class="radio-info" v-if="jag1 === 'j1'">
                                                    <div class="help-radio">
                                                        <div class="help-btn">
                                                            <label>
                                                                <input type="radio" name="radio2" value="fornman1" v-model="fornman">
                                                                <span class="radio radio1">I have already canceled my current agreement</span>

                                                            </label>

                                                            <label >
                                                                <input type="radio" name="radio2" value="fornman2" v-model="fornman">
                                                                <span class="radio radio2">Please cancel my current subscription and sign a new one</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <transition name="fade">
                                                        <div class="autofill" v-if="fornman == 'fornman2'">
                                                            <div class="form-group" >
                                                                <label @click="forfillLabelClick($event)">Fornamn</label>
                                                                <input type="text" class="form-control"
                                                                           @focus="formfillControlFocus($event)"
                                                                           @blur="formfillControlBlur($event)"
                                                                           v-model="companyFill"
                                                                           title="Telefonnummer">
                                                            </div>
                                                            <div class="fill-results">
                                                                <div class="fill__el" v-if="companyList">
                                                                    <div class="fill-list">

                                                                        <div class="fill-item">Fixed price 6 months <img src="../../../img/telinet.svg" alt=""></div>
                                                                        <div class="fill-item">Fixed price 6 months <img src="../../../img/telinet.svg" alt=""></div>
                                                                        <div class="fill-item">Fixed price 6 months <img src="../../../img/telinet.svg" alt=""></div>
                                                                        <div class="fill-item">Fixed price 6 months <img src="../../../img/telinet.svg" alt=""></div>
                                                                        <div class="fill-item">Fixed price 6 months <img src="../../../img/telinet.svg" alt=""></div>
                                                                        <div class="fill-item">Fixed price 6 months <img src="../../../img/telinet.svg" alt=""></div>
                                                                        <div class="fill-item">Fixed price 6 months <img src="../../../img/telinet.svg" alt=""></div>
                                                                        <div class="fill-item">Fixed price 6 months <img src="../../../img/telinet.svg" alt=""></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </transition>
                                                </div>
                                            </transition>
                                        </div>
                                        <div class="radio-item help-radio">
                                            <label>
                                                <input type="radio" class="main-radio" name="radio1" value="j2" v-model="jag1">
                                                <span class="radio"></span>
                                                <span class="p-black min p-bold p-black">Jag är nyinflyttad/ska flytta</span>
                                            </label>
                                            <transition name="fade">
                                                <div class="radio-info" v-if="jag1 === 'j2'">
                                                    <div class="title">
                                                        <p class="min  p-black">Har en inflyttsanmälan gjorts till ditt
                                                            elnätsbolag Trollhättan Energi Elnät AB</p>
                                                        <p class="minimum">Elnätsbolag är det bolag som äger kablarna till
                                                            din nya bostad</p>
                                                    </div>
                                                    <div class="help-radio">
                                                        <div class="help-btn">
                                                            <label>
                                                                <input type="radio" name="radio2">
                                                                <span class="radio radio1">No, help me with this</span>

                                                            </label>
                                                            <label>
                                                                <input type="radio" name="radio2">
                                                                <span class="radio radio2">Yes, it’s done!</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                <div class="radio-info__desk">
                                                    <ul>
                                                        <li>
                                                            You dont need to cancel the contract, we help you with this for you
                                                        </li>
                                                        <li>
                                                            Always 14 days of notice
                                                        </li>
                                                    </ul>
                                                    <button class="btn-default" @click="openVilkorModal()" >Villkor</button>
                                                </div>

                                            </div>
                                            </transition>
                                        </div>
                                        <div class="error-text">
                                            <span>some error Enter your phone number to fill in the remaining data</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="titles">
                                    <p class="med p-black p-bold">Customer details </p>
                                </div>
                                <div class="info__blck">
                                    <p class="Raleway minimum">Enter your phone number to fill in the remaining data. We
                                        will never contact you in order to sell anything.</p>
                                </div>
                                <div class="form-group question error">
                                    <label @click="forLabelClick($event)"><img src="../../../img/icon/exclamation-sign.svg" alt="">Telefonnummer Telefonnummer Telefonnummer TelefonnummerTelefonnummer</label>
                                    <input type="text" class="form-control"
                                           @focus="formControlFocus($event)"
                                           @blur="formControlBlur($event)"
                                           title="Telefonnummer">
                                    <span class="question_toogler"
                                          @click="openToolTips($event, 1)"
                                          v-click-outside="closeToolTips"
                                    ></span>
                                </div>
                                <div class="btns btns-center">
                                    <div class="row justify-content-end">
                                        <div class="col-md-6 py-0">
                                            <button class="btn btn-green btn-green2 btn-full btn-squere btn-capitalize">Continue</button>
                                        </div>
                                    </div>

                                </div>
                                <div class="titles">
                                    <p class="med p-black p-bold">Bostadsinformation</p>
                                </div>
                                <div class="form-group" :class="{'active': dateOpen}">
                                    <label @click="forLabelClick($event)">Vanligen ange dina adressuppgifter forst</label>

                                    <input type="text" class="form-control brd_btm_none"
                                           @focus="formControlFocus($event)"
                                           @blur="formControlBlur($event)"
                                           disabled
                                           title="Telefonnummer">

                                </div>




                                <div class="form-group question mb-0 disabled">
                                    <label @click="forLabelClick($event)">Personnummer (AAMMDDXXXX)</label>
                                    <input type="text" class="form-control brd_btm_none"
                                           @focus="formControlFocus($event)"
                                           @blur="formControlBlur($event)"
                                           disabled
                                           title="Telefonnummer">
                                    <span class="question_toogler"
                                          @click="openToolTips($event, 1)"
                                          v-click-outside="closeToolTips"
                                    ></span>
                                </div>
                                <div class="row mx-0">
                                    <div class="col-6 px-0">
                                        <div class="form-group disabled">
                                            <label @click="forLabelClick($event)">Fornamn</label>
                                            <input type="text" class="form-control brd_rght_none"
                                                   @focus="formControlFocus($event)"
                                                   @blur="formControlBlur($event)"
                                                   disabled
                                                   title="Telefonnummer">
                                        </div>
                                    </div>
                                    <div class="col-6 px-0">
                                        <div class="form-group disabled ">
                                            <label @click="forLabelClick($event)">Efternamn</label>
                                            <input type="text" class="form-control"
                                                   @focus="formControlFocus($event)"
                                                   @blur="formControlBlur($event)"
                                                   disabled
                                                   title="Telefonnummer">
                                        </div>
                                    </div>
                                </div>
                                <div class="titles">
                                    <p class="med p-black p-bold">Facility information</p>
                                </div>
                                <div class="row mx-0">
                                    <div class="col-6 px-0">

                                        <div class="form-group error mb-0">
                                            <label @click="forLabelClick($event)"><img src="../../../img/icon/exclamation-sign.svg" alt="">Postcode</label>
                                            <input type="text" class="form-control  brd_btm_none  brd_rght_none"
                                                   @focus="formControlFocus($event)"
                                                   @blur="formControlBlur($event)"

                                                   title="Telefonnummer">
                                        </div>
                                    </div>
                                    <div class="col-6 px-0">
                                        <div class="form-group mb-0">
                                            <label @click="forLabelClick($event)">City</label>
                                            <input type="text" class="form-control brd_btm_none "
                                                   @focus="formControlFocus($event)"
                                                   @blur="formControlBlur($event)"

                                                   title="Telefonnummer">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group question error mb-0">
                                    <label @click="forLabelClick($event)"><img src="../../../img/icon/exclamation-sign.svg" alt="">Adress</label>
                                    <input type="text" class="form-control brd_btm_none"
                                           @focus="formControlFocus($event)"
                                           @blur="formControlBlur($event)"

                                           title="Telefonnummer">
                                </div>
                                <div class="form-group mb-20 question cant-now-btn">
                                    <label @click="forLabelClick($event)">Anlaggning ID</label>
                                    <input type="text" class="form-control"
                                           @focus="formControlFocus($event)"
                                           @blur="formControlBlur($event)"
                                           title="Telefonnummer">
                                    <span class="question_toogler"
                                          @click="openToolTips($event, 2)"
                                          v-click-outside="closeToolTips"
                                    ></span>
                                    <button class="cant-now btn btn-blue"

                                        @click="openAnlaggningModal()"

                                    >I don’t know?</button>
                                </div>
                                <div class="mini-checkbox error">
                                    <div class="checks">

                                        <input type="checkbox" id="check1" />
                                        <span></span>

                                    </div>
                                    <label for="check1">
                                        I don’t know?
                                        <img src="../../../img/icon/little-man.svg" alt="">
                                    </label>
                                    <span class="error-text">somee Anlaggning ID error</span>

                                </div>
                                <div class="mini-checkbox disabled">
                                    <div class="checks">
                                        <input type="checkbox" id="check3" disabled/>
                                        <span></span>
                                    </div>
                                    <label for="check3">
                                        I don’t know?
                                        <img src="../../../img/icon/little-man.svg" alt="">
                                    </label>
                                </div>
                                <div class="titles radio-title error">
                                    <p class="med p-black p-bold">I live in:</p>
                                    <div class="radio-group ">
                                        <div class="radio-item">
                                            <label>
                                                <input type="radio" class="main-radio" name="radio3">
                                                <span class="radio"></span>
                                                <span class="min">Villa <img src="../../../img/icon/villa.svg" alt=""></span>
                                            </label>
                                        </div>
                                        <div class="radio-item">
                                            <label>
                                                <input type="radio" class="main-radio" name="radio3">
                                                <span class="radio"></span>
                                                <span class="min">Apartment <img src="../../../img/icon/apartments.svg" alt=""></span>
                                            </label>
                                        </div>

                                    </div>
                                    <span class="error-text">somee Anlaggning ID error</span>
                                </div>
                                <div class="titles radio-title">
                                    <p class="med p-black p-bold">I live in:</p>
                                    <div class="radio-group disabled">
                                        <div class="radio-item">
                                            <label>
                                                <input type="radio" class="main-radio" name="radio3" disabled>
                                                <span class="radio"></span>
                                                <span class="min">Villa <img src="../../../img/icon/villa.svg" alt=""></span>
                                            </label>
                                        </div>
                                        <div class="radio-item">
                                            <label>
                                                <input type="radio" class="main-radio" name="radio3" disabled checked>
                                                <span class="radio"></span>
                                                <span class="min">Apartment <img src="../../../img/icon/apartments.svg" alt=""></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group question error">
                                    <label @click="forLabelClick($event)">Same as plant address </label>
                                    <input type="text" class="form-control"
                                           @focus="formControlFocus($event)"
                                           @blur="formControlBlur($event)"
                                           title="Telefonnummer">
                                    <span class="question_toogler"
                                          @click="openToolTips($event, 3)"
                                          v-click-outside="closeToolTips"
                                    ></span>
                                    <span class="error-text">Same error text text</span>

                                </div>

                                <div class="titles">
                                    <p class="med p-black p-bold">Agreements Home</p>
                                </div>
                                <div class="form-group date_picker" :class="{'active': dateOpen}">
                                    <label
                                            @click="formDateLabelOpen($event)"
                                            for="">Choose date</label>

                                    <datepicker
                                            :input-class="'form-control  disabled'"
                                            :disabled-dates="disDate"
                                            @opened="formDateOpen($event)"
                                            @closed="formDateClose($event)"
                                            @click="ClickEvent($event)"

                                    ></datepicker>

                                </div>
                                <div class="titles">
                                    <p class="med p-black p-bold">Fakturaadress</p>
                                </div>
                                <div class="form-group edit-btn">
                                    <label @click="forLabelClick($event)">Same as plant address Same as plant address</label>
                                    <input type="text" class="form-control"
                                           @focus="formControlFocus($event)"
                                           @blur="formControlBlur($event)"
                                           title="Telefonnummer">
                                    <button class="edit" @click="openmodalEditAddress()">Ändra</button>
                                </div>
                                <div class="address-result">
                                    <div class="main-result">
                                        <p class="text min">Same as plant address Same as plant address</p>
                                    </div>
                                    <button class="edit" @click="openmodalEditAddress()">Ändra</button>
                                </div>
                                <div class="address-result disabled">
                                    <div class="main-result">
                                        <p class="text min">Same as plant address Same as plant address</p>
                                    </div>
                                    <button class="edit" disabled @click="openmodalEditAddress()">Ändra</button>
                                </div>
                                <div class="address-result">
                                    <div class="main-result">
                                        <p class="name min p-bold p-black">Dennis Svensson</p>
                                        <p class="text min">Karmander, Markavardsgaatan 15, <br />
                                            113 52, Stockholm <br />
                                            dennis_thn@hotmai.com, 073 • • • 380

                                        </p>
                                    </div>
                                    <button class="edit" @click="openmodalEditAddress()">Ändra</button>
                                </div>
                                <div class="mini-checkbox mini-checkbox2">
                                    <div class="checks">
                                        <input type="checkbox" name="check2" id="check2" />
                                        <span></span>
                                    </div>
                                    <label for="check2">
                                        <span>Jag ger TecknaEl
                                            <a href="https://cdn.tecknael.se/dokument/misc/fullmakt-tecknael.pdf" target="_blank" class="">
                                                fullmakt</a>
                                            att
                                            hämta uppgifter från min nätägare och avsluta mitt elavtal hos Almnäs Elhandel</span>
                                    </label>
<!--                                    <label for="check2">-->
<!--                                        I accept that TecknaEL helps me to sign a contract with company in tyoe of full-power-->
<!--                                    </label>-->
                                </div>
                                <div class="btns">
                                    <div class="row justify-content-center">
                                        <div class="col-md-8 py-0">
                                            <button class="btn btn-green  btn-green2 btn-full btn-squere btn-capitalize btn-disabled" disabled>Slutför köp</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="description p-center">
                                    <p class="minimum">Genom att klicka på "Slutför köp" godkänner jag Klarnas Användarvillkor och bekräftar att jag har läst Klarnas Dataskyddspolicy. Jag godkänner villkoren för Ridestore AB.</p>
                                    <img src="../../../img/telinet.svg" alt="">
                                </div>

                            </div>

                        </div>
                    <div class="checkout_info">
                        <div class="second__blck d-md-none">

                            <div class="price__info">
                                <div class="collapsible__el" :class="{'active': collapses2}">
                                    <div class="title_el" @click="collapses2 = !collapses2">
                                        <p class="p-white  p-bold">Fixed Price</p>
                                        <p class="min-min p-white">Show details <img
                                                src="/img/icon/arrow-down-white.svg" alt=""></p>
                                    </div>
                                    <transition name="fade">
                                        <div class="content" v-if="collapses2">
                                            <div class="row">
                                                <div class="col-8">
                                                    <div class="title">
                                                        <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                        <p class="p-gray2 minimum">(incl. electricity certificate, excl.
                                                            VAT)</p>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="cost">
                                                        <p class="p-dgrey med-max">45.90</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-8">
                                                    <div class="title">
                                                        <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                        <p class="p-gray2 minimum">(incl. electricity certificate, excl.
                                                            VAT)</p>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="cost">
                                                        <p class="p-dgrey med-max">45.90</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-8">
                                                    <div class="title">
                                                        <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                        <p class="p-gray2 minimum">(incl. electricity certificate, excl.
                                                            VAT)</p>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="cost">
                                                        <p class="p-dgrey med-max">45.90</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-8">
                                                    <div class="title">
                                                        <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                        <p class="p-gray2 minimum">(incl. electricity certificate, excl.
                                                            VAT)</p>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="cost">
                                                        <p class="p-dgrey med-max">45.90</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </transition>
                                    <div class="less_price">
                                        <div class="row align-items-center">
                                            <div class="col-6 col-md-6 col-lg-7">
                                                <div class="total">
                                                    <p class="p-blue">Total:</p>
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-6 col-lg-5">
                                                <div class="total-cost">
                                                    <p class="p-black">
                                                        <span class="number">1250</span>
                                                        <span>kr</span>
                                                        <span>month SEK</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bindings">
                                <div class="collapsible__el " :class="{'active': collapses1}">
                                    <div class="title_el" @click="collapses1 = !collapses1">
                                        <p class="min"><b>Binding time</b>
                                            <span class="quest__in_icon">
                                                    </span>
                                        </p>
                                        <p class="min p-blue">9 months</p>
                                    </div>
                                    <transition name="fade">
                                        <div class="content" v-if="collapses1">
                                            <p class="min-min">If the consumer chooses to break the contract entered in
                                                early, the Lighthouse has the right to charge a ransom fee. This
                                                exercise fee is calculated at 20% of the agreed energy price for
                                                estimated consumption during the remaining part of the contract period
                                                plus an administrative fee of SEK 450 incl. VAT. The remaining contract
                                                period is counted in whole months. The monthly consumption is calculated
                                                as one twelfth of the annual consumption stated by the electricity grid
                                                owner last. At the customer's definitive relocation, where no new plant
                                                is put into use, the agreement can be terminated prematurely without a
                                                ransom charge being charged.</p>
                                        </div>
                                    </transition>

                                </div>

                            </div>

                            <div class="garant desktop__none">
                                <div class="garant__items">
                                    <div class="garant-item">
                                        <div class="img">
                                            <img src="/img/candel.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <p class="min-min p-dgrey">A switch never causes any power failure</p>
                                        </div>
                                    </div>
                                    <div class="garant-item">
                                        <div class="img">
                                            <img src="/img/cash2.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <p class="min-min p-dgrey">In average our customers save 2000 Kr/year</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            <div class="modals">
                <div class="info-popup open edit-address" v-if="modalEditAddress">
                    <div class="popupoverlay"   @click="openmodalEditAddress()"></div>
                    <div class="mainpopup">
                        <div class="close" @click="openmodalEditAddress()"></div>
                        <div class="popup_body">

                            <div class="title p-center">
                                <p class="Raleway p-black max-max"><b>Lagg till en leveransadress</b></p>
                            </div>
                            <div class="modal-form">
                                <div class="row mx-0">
                                    <div class="col-6 px-0">

                                        <div class="form-group error  mb-0">
                                            <label @click="forLabelClick($event)">Email address</label>
                                            <input type="text" class="form-control brd_btm_none brd_rght_none control-square"
                                                   @focus="formControlFocus($event)"
                                                   @blur="formControlBlur($event)"

                                                   title="Email address">
                                        </div>
                                    </div>
                                    <div class="col-6 px-0">
                                        <div class="form-group mb-0">
                                            <label @click="forLabelClick($event)">Post number</label>
                                            <input type="text" class="form-control brd_btm_none control-square"
                                                   @focus="formControlFocus($event)"
                                                   @blur="formControlBlur($event)"

                                                   title="Post number">
                                        </div>
                                    </div>
                                </div>
                                <div class="row mx-0">
                                    <div class="col-6 px-0">

                                        <div class="form-group error mb-0">
                                            <label @click="forLabelClick($event)">Fornamn</label>
                                            <input type="text" class="form-control brd_btm_none brd_rght_none control-square"
                                                   @focus="formControlFocus($event)"
                                                   @blur="formControlBlur($event)"

                                                   title="Fornamn">
                                        </div>
                                    </div>
                                    <div class="col-6 px-0">
                                        <div class="form-group mb-0">
                                            <label @click="forLabelClick($event)">Afternamn</label>
                                            <input type="text" class="form-control brd_btm_none control-square"
                                                   @focus="formControlFocus($event)"
                                                   @blur="formControlBlur($event)"

                                                   title="Afternamn">
                                        </div>
                                    </div>
                                </div>
                                <div class="row mx-0">
                                    <div class="col-12 px-0">

                                        <div class="form-group  mb-0">
                                            <label @click="forLabelClick($event)">Address</label>
                                            <input type="text" class="form-control brd_btm_none control-square"
                                                   @focus="formControlFocus($event)"
                                                   @blur="formControlBlur($event)"

                                                   title="Address">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mx-0">
                                <div class="col-6 px-0">

                                    <div class="form-group error">
                                        <label @click="forLabelClick($event)">Ort</label>
                                        <input type="text" class="form-control brd_rght_none control-square"
                                               @focus="formControlFocus($event)"
                                               @blur="formControlBlur($event)"

                                               title="Ort">
                                    </div>
                                </div>
                                <div class="col-6 px-0">
                                    <div class="form-group error">
                                        <label @click="forLabelClick($event)"><img src="../../../img/icon/exclamation-sign.svg" alt="">Phone number</label>
                                        <input type="text" class="form-control  control-square"
                                               @focus="formControlFocus($event)"
                                               @blur="formControlBlur($event)"

                                               title="Phone number">
                                    </div>
                                </div>
                            </div>
                            <div class="submit__btn">
                                <div class="row">

                                    <div class="col-md-12">
                                        <button class="btn btn-green btn-full small">And</button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-popup open analggig-popup" v-if="AnlaggningModal">
                    <div class="popupoverlay"   @click="openAnlaggningModal()"></div>
                    <div class="mainpopup">
                        <div class="close" @click="openAnlaggningModal()"></div>
                        <div class="popup_body">

                            <div class="title p-center">
                                <p class="Raleway p-black max-max"><b>Anlaggning ID </b></p>

                            </div>
                            <div class="anlaggning-content">
                                <p class="p-center p-black">Number is usually shown on the second page where the invoice specifications is shown and it's also shown in the upper area</p>
                                <img src="../../../img/Contract_1.svg" alt="" class="img-1">
                                <img src="../../../img/Contract_2.png" alt="" class="img-2">
                                <div class="mini-checkbox">
                                    <div class="checks">

                                        <input type="checkbox" />
                                        <span></span>

                                    </div>
                                    <label for="">
                                        I don’t know? I don’t know? I don’t know? I don’t know? I don’t know? I don’t know? I don’t know? vI don’t know?
                                        <img src="../../../img/icon/little-man.svg" alt="">
                                    </label>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-popup open  villkor-popup" v-if="VilkorModal">
                    <div class="popupoverlay"   @click="openVilkorModal()"></div>
                    <div class="mainpopup">
                        <div class="close" @click="openVilkorModal()"></div>
                        <div class="popup_body">

                            <div class="title p-center">
                                <p class="Raleway p-black max-max"><b>TecknaEL </b></p>

                            </div>
                            <div class="content">
                                <h4 class="p-black min p-bold">Lorem ipsum dolor</h4>
                                <p class="min-min">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum </p>
                                <h4 class="p-black min p-bold">Lorem ipsum dolor</h4>
                                <p class="min-min">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum </p>
                                <h4 class="p-black min p-bold">Lorem ipsum dolor</h4>
                                <p class="min-min">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum </p>
                                <h4 class="p-black min p-bold">Lorem ipsum dolor</h4>
                                <p class="min-min mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <review :bgColor="true"></review>
        <garant-sect></garant-sect>
        <div class="new-tooltips"
             v-show="tooltip"
             ref="ToolTips"
             :style="ToolStyles"
             :class="ToolClass"
        >
            <div class="main-tooltip">
                <span class="one-rct"></span>
                <span class="sec-rct "></span>
                <div class="content " ref="ToolTipsContent">
                    {{tipsContent}}
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import StepSection from "./page-part/StepSection";
    import GarantSect from "./page-part/GarantSect";
    import Datepicker from 'vuejs-datepicker';
    import Review from "../indexPartials/review";
    var disDate = {
        to: new Date(2019, 11, 5),
        from: new Date(2019, 11, 26)
    };
    const Tooltips = [
        {id: 1, text: '<p>We contact your provider and ask for your Facility-ID a confirmation will be sent to <a href=\"#\">youremailadress@mail.se</a> after you confirm the insurnace</p>'},
        {id: 2, text: '<p> sent to <a href=\"#\">youremailadress@mail.se</a>  after you confirm the insurnac after you confirm the insurnac after you confirm the insurnac after you confirm the insurnac after you confirm the insurnac after you confirm the insurnace</p>'},
        {id: 3, text: '<p>wrong if text is short</p>'},
        {id: 4, text: '<p> sent to <a href=\"#\">youremailadress@mail.se</a> after you confirm the insurnace</p>'}

    ];


    export default {
        name: "checkoutNew",
        components: {
            StepSection,
            Datepicker,
            Review,
            GarantSect
        },
        data: function () {
            return {
                disDate: disDate,
                fornman: null,
                modalEditAddress: false,
                collapses2: false,
                collapses1: false,
                dateOpen: false,
                tipsContent: '',
                tooltip: false,
                AnlaggningModal: false,
                VilkorModal: false,
                ToolClass: 'top',
                show: false,
                jag1: 'j1',
                companyFill: '',
                companyList: true,
                ToolStyles : {
                                top: 0,
                                left: 0,
                            }
            }
        },
        methods: {
            formControlFocus($event) {
                $event.target.parentElement.classList.add('active');

            },
            formControlBlur($event) {
                if ($event.target.value === "") {
                    $event.target.parentElement.classList.remove('active');

                }

            },


            forLabelClick($event) {

                if (!$event.target.parentElement.classList.contains("disabled")) {
                    $event.target.parentElement.classList.add('active');
                    $event.target.parentElement.children[1].focus();

                }

            },
            openmodalEditAddress(){
                let paddingRight = window.innerWidth - document.body.offsetWidth;
                let scroll = window.scrollY;
                const scrollY = document.body.style.top;
                this.modalEditAddress =  !this.modalEditAddress;
              if(this.modalEditAddress) {
                  document.body.classList.add('no-scroll');
                  document.body.style.top = `-${scroll}px`;
                  document.body.style.paddingRight = paddingRight + 'px';
              } else {
                  document.body.classList.remove('no-scroll');
                  document.body.style.paddingRight = '';
                  window.scrollTo(0, parseInt(scrollY || '0') * -1);
              }

            },
            openAnlaggningModal(){
                let scroll = window.scrollY;
                const scrollY = document.body.style.top;
                let paddingRight = window.innerWidth - document.body.offsetWidth;
                this.AnlaggningModal =  !this.AnlaggningModal;
              if(this.AnlaggningModal) {
                  document.body.classList.add('no-scroll');
                  document.body.style.top = `-${scroll}px`;
                  document.body.style.paddingRight = paddingRight + 'px';
              } else {
                  document.body.classList.remove('no-scroll');
                  document.body.style.paddingRight = '';
                  window.scrollTo(0, parseInt(scrollY || '0') * -1);
              }

            },
            openVilkorModal(){
                let scroll = window.scrollY;
                const scrollY = document.body.style.top;
                let paddingRight = window.innerWidth - document.body.offsetWidth;
                this.VilkorModal =  !this.VilkorModal;
              if(this.VilkorModal) {
                  document.body.classList.add('no-scroll');
                  document.body.style.top = `-${scroll}px`;
                  document.body.style.paddingRight = paddingRight + 'px';
              } else {
                  document.body.classList.remove('no-scroll');
                  document.body.style.paddingRight = '';
                  window.scrollTo(0, parseInt(scrollY || '0') * -1);
              }

            },
            formfillControlFocus($event) {
                $event.target.parentElement.classList.add('active');
                this.companyList = true;
            },
            formfillControlBlur($event) {
                if ($event.target.value === "") {
                    $event.target.parentElement.classList.remove('active');

                }
                this.companyList = false;
            },


            forfillLabelClick($event) {
                this.companyList = true;
                if (!$event.target.parentElement.classList.contains("disabled")) {
                    $event.target.parentElement.classList.add('active');
                    $event.target.parentElement.children[1].focus();
                }

            },
            openToolTips(event, id) {
                if(!this.tooltip) {
                    this.tooltip = true;

                    this.$refs.ToolTipsContent.innerHTML = Tooltips.find(x => x.id === id).text;

                    const bind = event.target.getBoundingClientRect();

                    let LeftPosition = bind.x + (event.target.scrollWidth / 2);
                    let TopPosition = bind.y + bind.width + window.scrollY;

                    const elHeight = this.$refs.ToolTips.clientHeight;
                    let step;
                    if(window.innerWidth < 426){
                        step = 290
                    } else {
                        step = 335
                    }
                        this.ToolStyles.left = LeftPosition - step + 'px';

                    //TODO create exception to left position
                    if (bind.y < elHeight) {
                        this.ToolStyles.top = TopPosition + 10 + 'px';
                        this.ToolClass = 'top'
                    } else if ((window.scrollY + window.innerHeight) - TopPosition < elHeight) {
                        this.ToolStyles.top = TopPosition - elHeight - bind.height - 10 + 'px';
                        this.ToolClass = 'bottom'
                    } else {
                        this.ToolStyles.top = TopPosition + 10 + 'px';
                        this.ToolClass = 'top'
                    }
                } else {
                    this.tooltip = false
                }
            },
            closeToolTips(){
                //TODO close tooltip
                console.log("close");
            },
            formDateOpen($event){
                console.log($event);

            },
            formDateClose($event){
                console.log($event);
            },
            ClickEvent($event){
                console.log($event);
            },
            closetoogleshow(){
                this.show = false
            },
            formDateLabelOpen($event){
                $event.target.parentElement.children[1].children[0].children[0].click();
                this.dateOpen = !this.dateOpen;
            }


        }
    }
</script>

